import { API_BASE_URL } from '../config/api';

export interface ApiKeyItem {
  id: string;
  label: string;
  createdBy: string;
  createdAt: string;
  isActive: boolean;
}

export interface CreateApiKeyResponse {
  id: string;
  label: string;
  apiKey: string;
  createdAt: string;
}

async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...options.headers },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Request failed' }));
    throw new Error(err.message ?? 'Request failed');
  }
  if (res.status === 204) return undefined as T;
  return res.json();
}

export async function listApiKeys(): Promise<ApiKeyItem[]> {
  return request<ApiKeyItem[]>('/api-keys');
}

export async function createApiKey(label: string): Promise<CreateApiKeyResponse> {
  return request<CreateApiKeyResponse>('/api-keys', {
    method: 'POST',
    body: JSON.stringify({ label }),
  });
}

export async function revokeApiKey(id: string): Promise<void> {
  return request<void>(`/api-keys/${encodeURIComponent(id)}`, { method: 'DELETE' });
}
